import { clsx } from 'clsx';
import { forwardRef } from 'react';
import { inputClassNameBase } from './_common.mjs';
import { useInputAttributes } from './contexts.mjs';
import { jsx } from 'react/jsx-runtime';

const TextArea = /*#__PURE__*/forwardRef(function TextArea({
  className,
  ...restProps
}, reference) {
  const inputAttributes = useInputAttributes();
  return /*#__PURE__*/jsx("textarea", {
    ref: reference,
    className: clsx(className, inputClassNameBase(), 'np-text-area'),
    ...inputAttributes,
    ...restProps
  });
});

export { TextArea };
//# sourceMappingURL=TextArea.mjs.map
